import React, { useState, useEffect } from "react";

// components
import PRCard from "./PRCard";
import PRCardMobile from "./PRCardMobile";
import Button from "../button/Button";
import IrEmptyState from "./IrEmptyState";

// styles
import "./IrStyles.css";

const IrPressReleases = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_newsroom.json`;

  // states
  const [fetchedData, setFetchedData] = useState([]);
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    // console.log(data);
    setFetchedData(data.NEWSROOM["ENTRY"]);
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  const hasEntries = Array.isArray(fetchedData)
    ? fetchedData.length > 0
    : Boolean(fetchedData);

  return (
    <section id="ir-press-releases">
      <div className="px-7 py-20 lg:px-20">
        <div className="ir-press-releases-main-wrapper main-margin">
          <div className="ir-press-releases-img-wrapper">
            <h1 className="sub-header pb-8">Press Releases</h1>
          </div>
          <div class="main-margin table-shadow-main">
            {!hasEntries ? (
              <IrEmptyState message="No press releases available at this time." />
            ) : (
              <>
                {screenSize.dynamicWidth > 700 ? (
                  <div className="flex justify-between bg-gray-100">
                    <span className="p-4 text-xl">Title</span>
                    <span className="p-4 text-xl">Date</span>
                  </div>
                ) : null}
                {screenSize.dynamicWidth > 700 ? (
                  <div>
                    {Array.isArray(fetchedData) ? (
                      fetchedData.map((pr, i) => {
                        return (
                          <PRCard
                            key={pr.url || i}
                            releaseDate={pr.published_date}
                            title={pr.title}
                            link={pr.url}
                            showArrow={true}
                          />
                        );
                      })
                    ) : (
                      <PRCard
                        releaseDate={fetchedData.published_date}
                        title={fetchedData.title}
                        link={fetchedData.url}
                        showArrow={true}
                      />
                    )}
                  </div>
                ) : (
                  <div>
                    {Array.isArray(fetchedData) ? (
                      fetchedData.map((pr, i) => {
                        return (
                          <PRCardMobile
                            key={pr.url || i}
                            releaseDate={pr.published_date}
                            title={pr.title}
                            link={pr.url}
                            showArrow={true}
                          />
                        );
                      })
                    ) : (
                      <PRCardMobile
                        releaseDate={fetchedData.published_date}
                        title={fetchedData.title}
                        link={fetchedData.url}
                        showArrow={true}
                      />
                    )}
                  </div>
                )}
              </>
            )}
          </div>
          <div className="mt-5">
            {fetchedData && fetchedData.length > 4 ? (
              <Button disabled={false} color="bg-hmcBlue">
                LOAD MORE
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IrPressReleases;
